import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CoinProvider } from "./core";
import Home from "./pages/home";
import Blog from "./pages/blog";

function App() {
  return (
    <CoinProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<Blog />} />
        </Routes>
      </BrowserRouter>
    </CoinProvider>
  );
}

export default App;